<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mb-4 mx-4">
      <div class="flex justify-center items-center">
        <p class="text-2xl mt-2.5 text-root-2 font-bold">Disapprove Batch ?</p>
      </div>
      <div class="mt-4">
        <p style="word-break: normal" class="text-root-4 text-13px font-normal">
          Kindly state reason for disapproving all transactions with Batch Date
          <i class="baseline-date_range"></i>
          <span class="font-bold">{{ routeDetails.id }}</span> below:
        </p>
      </div>
      <div class="mt-2.5">
        <el-form
          label-position="top"
          :model="disapproveBatchForm"
          ref="disapproveBatchForm"
          label-width="80px"
          :rules="rules"
          size="normal"
        >
          <el-form-item prop="reason">
            <el-input
              type="textarea"
              v-model="disapproveBatchForm.reason"
              placeholder="Type here"
            ></el-input>
          </el-form-item>
          <div class="mt-6">
            <o-button @click="validateForm('disapproveBatchForm')">{{
              !isLoading ? 'Submit Request' : 'Submitting..'
            }}</o-button>
          </div>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import OButton from '../../ui/OButton.vue'
export default {
  name: 'DisapproveBatchDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    batchDetails: {
      type: Object,
      required: true
    }
  },
  components: {
    OButton
  },
  data () {
    return {
      breakpoints,
      isLoading: false,
      disapproveBatchForm: {
        reason: ''
      },
      rules: {
        reason: [
          {
            required: true,
            message: 'Please input reason',
            trigger: ['blur', 'change']
          },
          {
            min: 2,
            message: 'Please input reason ',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    showDoneDialog () {
      this.$emit('showDisapproveDoneDialog')
    },
    validateForm (disapproveBatchForm) {
      this.isLoading = true
      this.$refs[disapproveBatchForm].validate((valid) => {
        if (valid) {
          if (this.batchDetails.type === this.$transactionType.TRANSFER) {
            this.cancelTerminalBatch()
          } else if (this.batchDetails.type === this.$transactionType.DEPOSIT) {
            this.cancelDepositBatch()
          } else if (
            this.batchDetails.type === this.$transactionType.WITHDRAWAL
          ) {
            this.cancelWithdrawalBatch()
          }
        } else {
          this.isLoading = false
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing information',
            position: 'top-right'
          })
        }
      })
    },
    cancelTerminalBatch () {
      this.isLoading = true
      const info = {
        batchDate: this.routeDetails.id,
        reason: this.disapproveBatchForm.reason
      }
      const vm = this
      this.$store
        .dispatch('externalApi/cancelTerminalTransferBatch', info)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
          this.showDoneDialog()
        })
    },
    cancelDepositBatch () {
      this.isLoading = true
      const info = {
        batchDate: this.routeDetails.id,
        reason: this.disapproveBatchForm.reason
      }
      const vm = this
      this.$store
        .dispatch('externalApi/cancelTreasuryDepositBatch', info)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
          this.showDoneDialog()
        })
    },
    cancelWithdrawalBatch () {
      this.isLoading = true
      const info = {
        batchDate: this.routeDetails.id,
        reason: this.disapproveBatchForm.reason
      }
      const vm = this
      this.$store
        .dispatch('externalApi/cancelTreasuryWithdrawalBatch', info)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
          this.showDoneDialog()
        })
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '37%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    routeDetails () {
      return {
        id: this.$route.params.id,
        status: this.$route.query.status,
        currency: this.$route.query.currency
      }
    }
  }
}
</script>

<style scoped>
>>> .el-textarea__inner {
  height: 200px;
}
</style>
